import React, { useContext, useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { useParams } from "react-router-dom";
import { LanguageContext } from "../../Contexts/LanguageContext";
import Footer from "../Shared/Footer/Footer";
import Navbar from "../Shared/Navbar/Navbar";
import productsData from "../Shared/productData";

const ProductDetail = () => {
  const { id } = useParams();
  const [product, setProduct] = useState({});
  useEffect(() => {
    const productDetail = productsData.filter((product) => product.id == id);
    setProduct(productDetail[0]);
  }, []);
  const [isBangla, setIsBangla] = useContext(LanguageContext);
  const keywords = product.keywords;
  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{`${product.name}`} | Biotech</title>
        <meta name="keywords" content={{keywords}, "biotech", "biotech pharma", "biotech pharmaceuticals", "biotech pharmaceutical", "biotech ay", "biotech (ay)", "biotech pharma (ay)", "biotech pharmaceutical (ay)", "biotech pharmaceuticals (ay)"} />
      </Helmet>
      <Navbar />
      <div className="container">
        <div className="row">
          <div className="col-md-12 text-center">
            <h1 style={{ marginTop: "5vh" }}>{product.name}</h1>
            <h2 style={{ marginTop: "5vh" }}>{product.genericName}</h2>
            <p style={{ marginTop: "5vh", fontWeight: 500 }}>
              {isBangla ? product.banglaLargeDetail : product.largeDetail}
            </p>
          </div>
          <div className="col-md-7">
            <img src={product.img2} width="95%" alt="" />
          </div>
          <div className="col-md-5">
            <h2 style={{ color: "#6487FF", marginTop: "18vh" }}>
              Indications of {product.genericName}:
            </h2>
            <div>
              <p>
                {isBangla ? product.banglaIndication1 : product.indication1}
              </p>
              <p>
                {isBangla ? product.banglaIndication2 : product.indication2}
              </p>
              <p>
                {isBangla ? product.banglaIndication3 : product.indication3}
              </p>
              <p>
                {isBangla ? product.banglaIndication4 : product.indication4}
              </p>
              <p>
                {isBangla ? product.banglaIndication5 : product.indication5}
              </p>
              <p>
                {isBangla ? product.banglaIndication6 : product.indication6}
              </p>
              <p>
                {isBangla ? product.banglaIndication7 : product.indication7}
              </p>
              <p>
                {isBangla ? product.banglaIndication8 : product.indication8}
              </p>
              <p>
                {isBangla ? product.banglaIndication9 : product.indication9}
              </p>
              <p>
                {isBangla ? product.banglaIndication10 : product.indication10}
              </p>
              <p>
                {isBangla ? product.banglaIndication11 : product.indication11}
              </p>
              <p>
                {isBangla ? product.banglaIndication12 : product.indication12}
              </p>
              <p>
                {isBangla ? product.banglaIndication13 : product.indication13}
              </p>
              <p>
                {isBangla ? product.banglaIndication14 : product.indication14}
              </p>
            </div>
            <h2 style={{ color: "#6487FF", marginTop: "6vh" }}>
              {product.benefits}
            </h2>
            <div>
              <p>
                {isBangla ? product.banglaBenefit1 : product.benefit1}
              </p>
              <p>
                {isBangla ? product.banglaBenefit2 : product.benefit2}
              </p>
              <p>
                {isBangla ? product.banglaBenefit3 : product.benefit3}
              </p>
              <p>
                {isBangla ? product.banglaBenefit4 : product.benefit4}
              </p>
              <p>
                {isBangla ? product.banglaBenefit5 : product.benefit5}
              </p>
              <p>
                {isBangla ? product.banglaBenefit6 : product.benefit6}
              </p>
              <p>
                {isBangla ? product.banglaBenefit7 : product.benefit7}
              </p>
            </div>
            <h2 style={{ color: "#6487FF", marginTop: "6vh" }}>
              Doses & Administration:
            </h2>
            <p>
              {isBangla ? product.banglaDoses : product.doses}
            </p>
            <h2 style={{ color: "#6487FF", marginTop: "6vh" }}>Preparation:</h2>
            <p>
              {isBangla ? product.banglaPreparation : product.preparation}
            </p>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ProductDetail;
